type WarmupStepProps = {
  number: number
  text: string
  durationMinutes?: number
}

export function WarmupStep({ number, text, durationMinutes }: WarmupStepProps) {
  return (
    <div className="mb-3 flex items-start gap-3">
      <div className="mt-0.5 flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full border border-kilo-accent/25 bg-kilo-accent/10">
        <span className="font-mono text-[9px] text-kilo-accent">{number}</span>
      </div>
      <div className="flex-1">
        <p className="text-xs leading-relaxed text-neutral-300">{text}</p>
        {durationMinutes ? (
          <span className="mt-1.5 inline-flex items-center gap-1 rounded-full bg-kilo-accent/10 px-2 py-0.5 text-[10px] text-kilo-accent">
            ⏱ {durationMinutes} min
          </span>
        ) : null}
      </div>
    </div>
  )
}

export default WarmupStep
